if (process.browser && !('IntersectionObserver' in window)) {
  require('intersection-observer');
}
